module.exports = __webpack_public_path__ + "static/media/administration-smart.6beebb4e.svg";